import { useTranslation } from 'react-i18next';

export const useGroupOptions = () => {
  const { t } = useTranslation();

  return [
    { value: 'tester', label: t('common:groups.tester') },
    {
      value: 'mechanical',
      label: t('common:groups.developer'),
    },
  ];
};
